
import React, { useState, useTransition, use } from 'react';
import Modal from 'react-bootstrap/Modal';
import icon1 from '../images/debit.png'
import icon2 from '../images/credit.png'
import "../css/common.css"
import { Link, useNavigate,useLocation } from "react-router-dom";
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Offcanvas from 'react-bootstrap/Offcanvas';
import Logout from './logOut';
import Logo from '../images/logos.png'
import { useSelector} from "react-redux"
import emailjs from '@emailjs/browser';



export default function Common() {

  const [value, setValue] = React.useState(0);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const navigate = useNavigate()
  const location = useLocation()

  const back = () => window.history.back()
  const [file, setFile] = useState();
  function handleChange(e) {
    setFile(URL.createObjectURL(e.target.files[0]));
  }
  let currentTime = new Date();
  let options = { timeStyle: 'short', hour12: true };
  let timeString = currentTime.toLocaleTimeString('en-US', options);

  //////////////////////////////////////////////////////////////////////////////////////////////////////
  const [formState, setFormState] = useState({});

  const changeHandler = (event) => {
    setFormState({ ...formState, [event.target.name]: event.target.value });
    console.log(formState)
  };

  // const serviceId = 'service_z08nwwc'
  //   const templateId = 'template_zh2yccg'
  //   const publicKey = '1E3EtlJD8BKYRI7Jn'

  const handleclick = (event) => {

    const handleclick = (event) => {
      event.preventDefault();
  
      window.Email.send({
        SecureToken: "27d68705-c0fb-42ce-9398-0a80e7930099 ",
        To: "ja84don@gmail.com",
        From: `${formState.email}`,
        Subject: "This is the Feedback",
        Body: `${formState.fedMessage}`,
      }).then(() => alert("msg send sucessfully"));
  
    }
    // event.preventDefault();

    // const templateParams = {
    //   from_name: 'retail shop',
    //   from_email: formState.email,
    //   to_name: ownerid.data.name,
    //   message: formState.fedMessage ,
    // };

    // // Send the email using EmailJS
    // emailjs.send(serviceId, templateId, templateParams, publicKey)
    //   .then((response) => {
    //     console.log('Email sent successfully!', response);
        
    //   })
    //   .catch((error) => {
    //     console.error('Error sending email:', error) 
    //   });



  }

  //////////////////////////////////////////////////////////////////////////

  return (
    <>

      <div className='box'>
        <h6 className='time'>{timeString}</h6>

        <Navbar key={false} expand={false} bg="primary" data-bs-theme="dark">
          <Container fluid>
            <Navbar.Brand href="#"><img src={Logo} alt='logo' width={70} id="logo" /></Navbar.Brand>
            <Navbar.Toggle aria-controls={`offcanvasNavbar-false-${false}`} style={{ borderColor: 'white' }} />

            <Navbar.Offcanvas
              id={`offcanvasNavbar-false-${false}`}
              aria-labelledby={`offcanvasNavbarLabel-false-${false}`}
              placement="end"
              style={{ backgroundColor: "lavenderblush" }}
            >
              <div >
                <Offcanvas.Header closeButton style={{ backgroundColor: "lemonchiffon" }}>
                  <Offcanvas.Title id={`offcanvasNavbarLabel-false-${false}`}>
                    <img src='https://dragonflywellbeing.co.uk/wp-content/uploads/2021/02/Dragonfly-Wellbeing-Logo.png' alt='logo' width={130} />
                  </Offcanvas.Title>
                </Offcanvas.Header>
              </div>
              <Offcanvas.Body>
                <Nav className="justify-content-end flex-grow-1 pe-3">
                  <div className='comnprofile'>
                    <div className='profilepic'>
                      <i class="fa-solid fa-user" style={{ color: "#c0bfbc", }}></i>
                    </div>
                    <h5>Ajil</h5>
                  </div>
                  <hr></hr>
                  {/* <input type="file" onChange={handleChange} hidden /> */}
                  {/* <img src={file} alt='img' style={{ width: "100px", height: "100px", borderRadius: "50%" }} /> */}
                  <div className='slidenav'><Link to={`/msg`}>
                    <Nav.Link href="#action1">Home</Nav.Link></Link></div>
                  <div className='slidenav'><Nav.Link href="#action2">Contact</Nav.Link></div>
                  <div className='slidenav'><Nav.Link href="#action3">About Us</Nav.Link></div>
                  <div className='slidenav'><Nav.Link href="#action4">Issue</Nav.Link></div>
                  <div className='slidenav'><Nav.Link href="#action5">Help</Nav.Link></div>

                  <Nav.Link href="#action2">Link</Nav.Link>

                  <NavDropdown
                    title="Connect with Us"
                    id={`offcanvasNavbarDropdown-false-${false}`}
                  >
                    <NavDropdown.Item href="#action3">Action</NavDropdown.Item>
                    <NavDropdown.Item href="#action4">
                      Another action
                    </NavDropdown.Item>
                    <NavDropdown.Divider />
                    <NavDropdown.Item href="#action5">
                      Something else here
                    </NavDropdown.Item>
                  </NavDropdown>
                  <Logout />
                </Nav>
                <div className='socialmedias'>
                  <hr></hr>
                  <a href='#'><i class="fa-brands fa-facebook"></i></a>
                  <a href='#'><i class="fa-brands fa-instagram"></i></a>
                  <a href='#'><i class="fa-brands fa-x-twitter"></i></a>
                  <a href='#'><i class="fa-brands fa-linkedin-in"></i></a>
                </div>
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          </Container>
        </Navbar>
      </div>


      <div className='feedback' >
        {/* <button data-bs-toggle="modal" data-bs-target="#displyfeedback" className="feedback-style" >Feedback &nbsp;&nbsp;  <i style={{fontSize:"18px"}} class="fa-solid fa-comment-medical"></i></button> */}
        <Button onClick={handleShow} id="feedback-style" >
          Feedback &nbsp;&nbsp;  <i style={{ fontSize: "18px" }} class="fa-solid fa-comment-medical"></i>

        </Button>
      </div>

      <Modal show={show} onHide={handleClose} className='formfeed'>
        <Modal.Header closeButton>
          <Modal.Title>Feedback</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form style={{ padding: "10px" }}  >
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label><b>Email address</b></Form.Label>
              <Form.Control
                type="email"
                name="email"
                onChange={changeHandler}
                value={formState.email || ''}
                placeholder="Enter Your Mail ID" />
            </Form.Group>
            <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
              <Form.Label><b>Message</b></Form.Label>
              <Form.Control
                as="textarea"

                name='fedMessage'
                onChange={changeHandler}
                rows={3}
                value={formState.fedMessage || ''}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleclick}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>


      <div style={{ position: 'fixed', bottom: 0, left: 0, width: '100%', zIndex: 999 }}>
      <ButtonGroup style={{ width: '100%' }}>
        <Button className='leftbtn' as={Link} to="/debitlist" style={{ width: 'calc(33.33% - 1px)', backgroundColor: location.pathname === '/debitlist' ? 'blue' : 'gray' }}>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-credit-card-fill" viewBox="0 0 16 16">
  <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v1H0zm0 3v5a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7zm3 2h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1"/>
</svg>&nbsp;
CREDIT / DEBIT</Button>
        <Button className='centerbtn' as={Link} to="/customerlist" style={{ width: 'calc(33.33% - 2px)',borderRight: '2px solid white', borderLeft: '2px solid white', backgroundColor: location.pathname === '/customerlist' ? 'blue' : 'gray' }}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-people-fill" viewBox="0 0 16 16">
  <path d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6m-5.784 6A2.24 2.24 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.3 6.3 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1zM4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"/>
</svg>&nbsp;
CUSTOMER LIST</Button>
        <Button className='rightbtn' as={Link} to="/msg" style={{ width: 'calc(33.33% - 1px)', backgroundColor: location.pathname === '/msg' ? 'blue' : 'gray' }}>
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chat-square-text-fill" viewBox="0 0 16 16">
  <path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.5a1 1 0 0 0-.8.4l-1.9 2.533a1 1 0 0 1-1.6 0L5.3 12.4a1 1 0 0 0-.8-.4H2a2 2 0 0 1-2-2zm3.5 1a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1zm0 2.5a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1zm0 2.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1z"/>
</svg>&nbsp;
MESSAGE LIST</Button>
      </ButtonGroup>
    </div>

       {/* <div className='menubox'
        style={
          { position: 'fixed', bottom: 0, left: '50%', transform: 'translateX(-50%)' }
        } >

        <button onClick={back} style={{ backgroundColor: 'white' }} ><i class="fa-solid fa-arrow-left"></i></button>
        <Link to={`/addcustomer`}><span><img src={icon1} alt='icon' /></span></Link>
        <Link to={`/customerlist`}><i class="fa-solid fa-rectangle-list"></i></Link>
        <Link to={`/`}><i class="fa-solid fa-house"></i></Link>
        <Link to={`/msg`}><i class="fa-solid fa-message"></i></Link>
        <Link to={`/debitlist`}><span><img src={icon2} alt='icon' /></span></Link>
        <button onClick={() => window.history.forward()} style={{ backgroundColor: 'white' }}><i class="fa-solid fa-arrow-right"></i></button>

      </div>  */}
    </>
  )
}
